import gql from 'graphql-tag';

export default {
    deleteAccountMutation: gql`
        mutation DeleteAccount {
            deleteAccount {
                __typename
                success
            }
        }
    `,
};
